<template>
    <div
        class="tl-link-copy"
        :class="classes"
        @dblclick="copy()"
    >
        <span class="link text-4 text-dense font-code text-opaq">{{ link }}</span>

        <div class="copy">
            <Button
                :severity="copied ? 'success' : 'primary'"
                @click="copy()"
            >
                <div class="animation-wrapper">
                    <transition
                        mode="out-in"
                        name="fade-slide-y-1"
                    >
                        <i
                            v-if="!copied"
                            class="pi pi-copy text-opaq"
                        ></i>
                        <i
                            v-else
                            class="pi pi-check"
                        ></i>
                    </transition>
                </div>
            </Button>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    dense: Boolean,
    link: String,
    dark: Boolean,
    ellipsis: Boolean,
})
const injects = getInjects(props, inject)

const dense = computed(() => props.dense ?? injects.dense)
const link = computed(() => props.link ?? injects.link)
const dark = computed(() => props.dark ?? injects.dark)
const ellipsis = computed(() => props.ellipsis ?? injects.ellipsis)

const copied = ref(false)

const copy = async () => {
    try {
        await navigator.clipboard.writeText(props.link)
        copied.value = true
        setTimeout(() => {
            copied.value = false
        }, 3000)
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to copy: ', err)
    }
}

const classes = computed(() => {
    const out = []
    if (dense.value) out.push('dense')
    if (dark.value) out.push('dark')
    if (copied.value) out.push('copied')
    if (ellipsis.value) out.push('ellipsis')
    return out
})
</script>

<style lang="sass" scoped>
.tl-link-copy
    padding: 0 var(--padding-4)
    border-radius: var(--border-radius)
    background-color: var(--color-tint-extralight)
    position: relative
    max-width: 100%
    overflow: hidden
    padding-right: calc(45px + var(--padding-4))
    transition: var(--transition-default)
    height: calc(45px + var(--padding-4))
    display: flex
    align-items: center
    .animation-wrapper
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        display: flex
        justify-content: center
        align-items: center

    .link
        font-size: 16px
        transition: var(--transition-default)
    .copy
        position: absolute
        right: 5px
        top: 5px
        bottom: 5px
        display: flex
        align-items: center
        button
            height: 100%
    &.dense
        height: calc(30px + var(--padding-4))
        padding-right: calc(30px + var(--padding-4))
        .link
            font-size: 14px
    &.dark
        background-color: var(--color-white-tint-extralight)
        .link
            color: var(--color-white)
    &.copied
        background-color: var(--color-success-tint-extralight)
        .link
            color: var(--color-success)

    &.copied.dark
        background-color: var(--color-success-tint-light)
        .link
            color: var(--color-success)

    &.ellipsis
        .link
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
</style>
